import { useParams } from 'react-router-dom'
import { Purchase } from '../../shop/pages'

export const PurchaseWrapper = () => {
  const { id } = useParams<{ id: string }>()

  return <Purchase transactionId={id} />
}
